import React from 'react';
import { useGlobalState } from '../../../hooks';
import { formatChangelogValue } from '../helpers';

export const ChangelogItemRow = ({ item, columns, idColumn }) => {
  const [displayNames] = useGlobalState('displayNames');

  return (
    <tr className="row">
      <td className={columns[0].className}>
        {item.property === idColumn
          ? 'Id'
          : displayNames[item.property]?.display_name || item.property}
      </td>
      <td className={columns[1].className}>{formatChangelogValue('new', item)}</td>
      <td className={columns[2].className}>{formatChangelogValue('old', item)}</td>
    </tr>
  );
};
